export default __webpack_public_path__ + "static/media/beer-icon.212d5a9e.svg";